export default __webpack_public_path__ + "static/logo_bleu-fcb363687001c57a89ca829c83dd0178.png";